// // // //
// Client-safe constants shared between the `oauthClients` router and the UI.
// Kept out of the router module so the UI can import it without pulling
// server-only dependencies (prisma, etc.) into the client bundle.

/**
 * Typed error message returned by `oauthClients.revokeSecret` when a user tries
 * to revoke the last active secret of a client that still has active sessions.
 * The UI matches on `error.message` to offer rotate-first vs break-sessions.
 */
export const LAST_ACTIVE_SECRET_WITH_SESSIONS =
    "LAST_ACTIVE_SECRET_WITH_SESSIONS";

/**
 * Error message returned by the `oauthClients` mutations when a member of the
 * client's organization lacks the privileges to manage it. Also shown in the
 * tooltip on the disabled controls, so the UI + API explain it the same way.
 */
export const MANAGE_PERMISSION_REQUIRED =
    "Only organization owners, admins, or the member who created this client can make changes.";

/**
 * Search param the "new client" page appends when it redirects to the detail
 * page. The detail page creates the client's first secret on arrival and then
 * strips the param so a refresh doesn't create another one.
 */
export const FIRST_SECRET_PARAM = "firstSecret";
export const FIRST_SECRET_PARAM_VALUE = "1";
